import React from "react";
import { Route, Routes } from "react-router-dom";

import { HashRouter } from "react-router-dom";
import AboutPage from "../AboutPage/AboutPage";
import AppointmentPage from "../AppointmentPage/AppointmentPage";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage.js";
import Homepage3 from "../HomePage3/Homepage3";
import ProjectPage from "../ProjectPage/ProjectPage";
import ServicePageS2 from "../ServicePageS2/ServicePageS2";
import ServiceSinglePage from "../ServiceSinglePage/ServiceSinglePage";
import TermPage from "../TermPage/TermPage";

const AllRoute = () => {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          {/* <Route path='/' element={<Homepage />} /> */}
          {/* <Route path="/home" element={<Homepage />} /> */}
          <Route path="/contact" element={<ContactPage />} />
          {/* <Route path="/home2" element={<Homepage2 />} /> */}
          <Route path="/" element={<Homepage3 />} />
          <Route path="/about" element={<AboutPage />} />
          {/* <Route path="/service" element={<ServicePage />} /> */}
          <Route path="/service" element={<ServicePageS2 />} />
          <Route path="/service-single/:id" element={<ServiceSinglePage />} />
          <Route path="/project" element={<ProjectPage />} />
          {/* <Route path="/project-single/:id" element={<ProjectSinglePage />} /> */}
          <Route path="/appointment" element={<AppointmentPage />} />
          <Route path="/terms" element={<TermPage />} />
          {/* <Route path="/testimonial" element={<TestimonialPage />} /> */}
          {/* <Route path="/pricing" element={<PricingPage />} /> */}
          <Route path="/404" element={<ErrorPage />} />
          {/* <Route path="/blog-single/:id" element={<BlogDetails />} /> */}
          {/* <Route
            path="/blog-single-left-sidebar/:id"
            element={<BlogDetailsLeftSiide />}
          /> */}
          {/* <Route
            path="/blog-single-fullwidth/:id"
            element={<BlogDetailsFull />}
          />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-left-sidebar" element={<BlogPageLeft />} />
          <Route path="/blog-fullwidth" element={<BlogPageFullwidth />} />
          <Route path="/team-single/:id" element={<TeamSinglePage />} /> */}
          {/* <Route path="/login" element={<LoginPage />} /> */}
          {/* <Route path="/register" element={<SignUpPage />} /> */}
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        </Routes>
      </HashRouter>
    </div>
  );
};

export default AllRoute;
